module.exports = __webpack_public_path__ + "static/media/Shabnam-Light.3250dba4.eot";